//core
import {makeStyles} from "@mui/styles";
import {format} from "date-fns";

//hooks
import { useLocale } from "../../../../../customHooks/useLocale";

interface IDateTime {
  value: any;
}

const useStyles = makeStyles({
  text: {
    color: 'inherit'
  }
});

const DateTime = ({ value }: IDateTime) => {
  const styles = useStyles();
  const locale = useLocale();

  return (
    <span className={styles.text}>
      {
        !!value ? format(new Date(value), locale.format, {locale: locale.locale}) : '—'
      }
    </span>
  );
};

export default DateTime;
